import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GlobalProductsApi } from '../globalProducts.api';

export const useDeleteProduct = (businessPlanId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: GlobalProductsApi.deleteProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['globalProducts', businessPlanId] });
    },
  });
};
